import { PanelCategory, PanelConfig } from '@helios/panel-base'
import { CorporateActionsPanelComponent } from './lib/corporate-actions-panel.component'
import { CorporateActionsKey } from './panel-key'

export * from './lib/corporate-actions.module'
export * from './panel-key'

export const CorporateActionsPanelConfig: PanelConfig = {
  key: CorporateActionsKey,
  title: 'Corporate Actions',
  description:
    'Address reconciliation breaks and variances. View details, change status, and add notes.',
  category: PanelCategory.SUPPLEMENTARY,
  panelComponent: CorporateActionsPanelComponent,
  accessPermission: 'accessCorporateActionsPanel',
}
